<template>
  <div class="tile is-parent">
    <a v-bind:href="`/marathons/${this.marathon.id}/announcement`">
      <div class="video-card card p-4">
        <img v-bind:src="this.marathon.picture" v-bind:alt="this.marathon.title"
             class="video-cover card-image"/>
        <h4 class="">{{ this.marathon.title }}</h4>
        <div class="is-flex is-justify-content-space-between mt-2">
        <span v-if="this.marathon?.duration">
          <i class="fa-solid fa-hourglass"></i>
           ~{{ this.marathon.duration }} мин</span>
          <span v-if="this.marathon?.teachers?.length > 0">{{ this.marathon.teachers[0]?.name }}</span>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: 'MarathonCard',
  props: ['marathon'],
  methods: {},
}
</script>

